import { render, staticRenderFns } from "./DetalheProposta.vue?vue&type=template&id=a1b8e8d2&"
import script from "./DetalheProposta.vue?vue&type=script&lang=js&"
export * from "./DetalheProposta.vue?vue&type=script&lang=js&"
import style0 from "./DetalheProposta.vue?vue&type=style&index=0&id=a1b8e8d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports